import DefaultLanguageSelect from './DefaultLanguageSelect'

export default DefaultLanguageSelect
